import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { useState, useEffect, useContext } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { selectEmpleadosConReglasOSecuencias } from "../../../../modules/Personas/services/empleados-service";
import { useForm } from "react-hook-form";
import TurnosConvencionesContext from "../../store/modal-convenciones-context";
import {
    asignarTurnoEmpleado,
    selectTurnosSedes,
} from "../../../NominaTurnos/services/nomina-turnos-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormAsignarCuadroTurno = ({ modalState, onCreate }) => {
    const [selectTurnosEmpleados, setSelectTurnosEmpleados] = useState({
        turnosSedes: [],
        empleados: [],
    });

    const { refrescarConvenciones } = useContext(TurnosConvencionesContext);

    useEffect(async () => {
        const [turnosSedes, empleadosReglas] = await Promise.all([
            selectTurnosSedes(),
            selectEmpleadosConReglasOSecuencias(),
        ]);

        if (!turnosSedes.status || !empleadosReglas.status) {
            const message = !turnosSedes.status
                ? turnosSedes.message
                : empleadosReglas.message;

            return toast.error(message);
        }

        setSelectTurnosEmpleados({
            turnosSedes: turnosSedes.data,
            empleados: empleadosReglas.data,
        });
    }, []);

    const defaultValues = {
        empleados: [],
        fk_nomina_turno_sede: "",
        fechaCuadroTurnoFin: "",
        fechaCuadroTurnoInicio: "",
    };

    const form = useForm({ defaultValues });

    const onSubmit = async (data) => {
        const cuadroTurno = {
            ...data,
            fk_nomina_turno_sede: data.fk_nomina_turno_sede.value,
            empleados: data.empleados.map((emp) => emp.value),
        };

        const resp = await asignarTurnoEmpleado(cuadroTurno);
        if (!resp.status) return toast.error(resp.message);

        modalState.close();
        form.reset(defaultValues);
        onCreate(resp);
        refrescarConvenciones();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modalState.show}
            onSubmit={onSubmit}
            id="formAsignarTurnos"
            headerTitle="Asignar Turnos"
            closeModal={() => modalState.close()}
        >
            <Row>
                <Col sm={6}>
                    <SelectController
                        label="Colaborador"
                        isMulti={true}
                        options={selectTurnosEmpleados.empleados.map(
                            (empleado) => {
                                return {
                                    label: empleado.info_persona,
                                    value: empleado.id,
                                };
                            }
                        )}
                        name="empleados"
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                        control={form.control}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Turno"
                        errors={form.formState.errors}
                        control={form.control}
                        name="fk_nomina_turno_sede"
                        rules={REQUIRED_RULE}
                        options={selectTurnosEmpleados.turnosSedes.map(
                            (turnoSede) => {
                                return {
                                    label: turnoSede.info_asignacion_turno,
                                    value: turnoSede.id,
                                };
                            }
                        )}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        name="fechaCuadroTurnoInicio"
                        label="Fecha inicio del turno"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        name="fechaCuadroTurnoFin"
                        label="Fecha fin del turno"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAsignarCuadroTurno.propTypes = {
    modalState: PropTypes.object,
    onCreate: PropTypes.func,
};

export default FormAsignarCuadroTurno;
